import { Component, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { DatatableService } from 'src/app/services/datatable.service';

@Component({
  selector: 'app-client-export-list',
  templateUrl: './client-export-list.component.html',
  styleUrls: ['./client-export-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ClientExportListComponent implements AfterViewInit {


  constructor(private datatableService: DatatableService) { }

  ngAfterViewInit(): void {
    this.datatableService.init('kt_table_client_export_list');
  }

  fakeRows = Array.from({ length: 15 });

}
